<template>
  <div class="flow-page" v-loading="pageLoading">
    <!-- 客户信息 -->
    <div class="table-container">
      <div class="page-header">
        <div class="header-bar"></div>
        <div class="header-content">
          <h2 class="header-title">客户信息</h2>
          <div class="header-sub">CUSTOMER INFORMATION</div>
        </div>
      </div>
      <div class="card-body">
        <el-form :model="formData" ref="ruleForm" label-width="130px" class="audit-form">
          <el-row :gutter="30">
            <el-col :xs="24" :sm="12">
              <el-form-item label="客户名称">
                <el-input v-model="formData.customerName" clearable />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="业务员">
                <el-input v-model="formData.salesman" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :xs="24" :sm="12">
              <el-form-item label="联系人">
                <el-input v-model="formData.linkman" clearable />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="联系人电话">
                <el-input v-model="formData.linkmanPhone" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :xs="24" :sm="24">
              <el-form-item label="公司地址">
                <el-input v-model="formData.companyAddress" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :xs="24" :sm="12">
              <el-form-item label="创建登录账号">
                <el-radio-group v-model="createSysUser" @change="handleSysUserRadioChange">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="用户昵称">
                <el-input v-model="userName" clearable :disabled="isUserNameDisabled" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :xs="24" :sm="12">
              <el-form-item label="使用设备及场景">
                <el-input v-model="formData.useDevice" clearable />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
              <el-form-item label="分成模式">
                <el-radio-group v-model="formData.commissionModel" :disabled="isCommissionModelDisabled">
                  <el-radio label="0">按比例</el-radio>
                  <el-radio label="1">底价</el-radio>
                  <el-radio label="2">流量池</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="30">
            <el-col :xs="24" :sm="24">
              <el-form-item label="备注">
                <el-input v-model="formData.remark" clearable />
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 图片区域 -->
          <div class="section-divider"></div>
          <div class="section-title">图片资料</div>
          <div class="image-grid">
            <div class="image-block">
              <div class="image-block-label">使用设备图片</div>
              <div class="image-wrap">
                <el-image
                  v-if="formData.useDevicePicture"
                  class="detail-image"
                  :src="formData.useDevicePicture"
                  :preview-src-list="[formData.useDevicePicture]"
                  fit="cover"
                />
                <div v-else class="image-empty">
                  <i class="el-icon-picture-outline"></i>
                  <span>暂无图片</span>
                </div>
              </div>
            </div>
            <div class="image-block">
              <div class="image-block-label">公司营业执照</div>
              <div class="image-wrap">
                <el-image
                  v-if="formData.businessLicensePicture"
                  class="detail-image"
                  :src="formData.businessLicensePicture"
                  :preview-src-list="[formData.businessLicensePicture]"
                  fit="cover"
                />
                <div v-else class="image-empty">
                  <i class="el-icon-picture-outline"></i>
                  <span>暂无图片</span>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>

    <!-- 流程图 -->
    <div class="table-container">
      <div class="page-header">
        <div class="header-bar"></div>
        <div class="header-content">
          <h2 class="header-title">流程图</h2>
          <div class="header-sub">PROCESS DIAGRAM</div>
        </div>
      </div>
      <div class="card-body">
        <div v-html="str" class="process-diagram" v-if="str"></div>
        <div v-else class="empty-state">暂无流程图</div>
      </div>
    </div>

    <!-- 审批意见 -->
    <div class="table-container">
      <div class="page-header">
        <div class="header-bar"></div>
        <div class="header-content">
          <h2 class="header-title">审批意见</h2>
          <div class="header-sub">APPROVAL</div>
        </div>
      </div>
      <div class="card-body">
        <el-form :model="queryParams" label-width="100px" class="approval-form">
          <el-row :gutter="30">
            <el-col :xs="24" :sm="24">
              <el-form-item label="审批结果" required>
                <el-select v-model="queryParams.status" filterable placeholder="请选择审批结果" clearable style="width: 200px">
                  <el-option v-for="item in source" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="30">
            <el-col :xs="24" :sm="24">
              <el-form-item label="备注意见">
                <el-input type="textarea" :rows="4" v-model="queryParams.remark" placeholder="请输入备注意见" style="width: 60%" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="24" :sm="24">
              <el-form-item>
                <el-button type="primary" size="medium" @click="submitFlowComment" :loading="submitLoading">
                  <i class="el-icon-check"></i>
                  提交审批
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
  import { processInstanceImage, submitTask, getCustomerInfo } from "@/api/api.js";

  export default {
    name: 'flowCustomerAct',
    data() {
      return {
        id: this.$route.query && this.$route.query.id,
        processId: this.$route.query.processId,
        formData: {},
        userName: null,
        createSysUser: 0,
        isUserNameDisabled: true,
        isCommissionModelDisabled: true,
        pageLoading: false,
        submitLoading: false,
        str: "",
        queryParams: {
          status: null,
          remark: null
        },
        source: [
          { value: 1, label: "同意" },
          { value: 2, label: "不同意" },
        ],
      }
    },
    methods: {
      handleSysUserRadioChange(val) {
        if (val == 0) {
          this.isUserNameDisabled = true;
          this.isCommissionModelDisabled = true;
        } else {
          this.isUserNameDisabled = false;
          this.isCommissionModelDisabled = false;
        }
      },
      initDataProcessImage() {
        let params = { processInstanceId: this.processId }
        processInstanceImage(params).then(res => {
          this.str = res.data
        });
      },
      initData() {
        this.pageLoading = true;
        getCustomerInfo({ id: this.id }).then((res) => {
          this.formData = res.data.data;
        }).finally(() => {
          this.pageLoading = false;
        });
      },
      submitFlowComment() {
        if (!this.createSysUser) {
          this.createSysUser = '0';
        }
        if (this.createSysUser == '1') {
          if (!this.userName) {
            return this.$message.error("创建登录账号：用户昵称不能为空");
          }
          if (!this.formData.commissionModel) {
            return this.$message.error("创建登录账号：分成模式不能为空");
          }
        }
        if (!this.queryParams.remark || !this.queryParams.status) {
          return this.$message.error("请输入审批内容或结果");
        }
        this.submitLoading = true;
        let params = {
          ...this.queryParams,
          taskId: null,
          processInstanceId: this.processId,
          userName: this.userName,
          createSysUser: this.createSysUser
        }
        params.customerInformationDto = this.formData;
        submitTask(params).then(res => {
          if (res.data.code == 200) {
            this.$store.dispatch('tagsView/delView', this.$route);
            this.$router.push({ path: `/shipment/customerInformation` });
            this.$notify({
              title: '成功',
              message: '审批成功',
              type: 'success'
            });
          }
        }).finally(() => {
          this.submitLoading = false;
        });
      },
    },
    watch: {
      "$route": {
        handler(to, from) {
          if (to.name !== "flowCustomerAct") return;
          const newId = to.query && to.query.id;
          const oldId = this.id;
          if(newId === oldId) return;
          this.id = newId;
          this.processId = to.query && to.query.processId;
          this.initDataProcessImage();
          this.initData();
        },
        deep: true,
      },
    },
    mounted() {
      this.initDataProcessImage()
      this.initData()
    },
  };
</script>
<style scoped lang="less">
/* ================= 变量 ================= */
@primary:          #409EFF;
@primary-dark:     #337ECC;
@primary-light:    rgba(64, 158, 255, 0.08);
@text-primary:     #303133;
@text-regular:     #606266;
@text-secondary:   #909399;
@text-placeholder: #C0C4CC;
@border-color:     #EBEEF5;
@bg-page:          #F0F2F5;
@bg-card:          #FFFFFF;
@border-radius:    10px;
@success:          #67C23A;
@warning:          #E6A23C;
@danger:           #F56C6C;

/* ================= 页面 ================= */
.flow-page {
  min-height: 100vh;
  background: @bg-page;
  padding: 24px 16px 40px;
  box-sizing: border-box;
}

/* ================= 容器 ================= */
.table-container {
  max-width: 1100px;
  margin: 0 auto 20px;
  background: @bg-card;
  border-radius: @border-radius;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  overflow: hidden;

  .page-header {
    display: flex;
    align-items: center;
    background: linear-gradient(135deg, @primary, @primary-dark);
    padding: 18px 20px;
    gap: 12px;

    .header-bar {
      width: 5px;
      height: 36px;
      background: #ffffff;
      border-radius: 3px;
    }

    .header-content {
      .header-title {
        font-size: 18px;
        font-weight: 600;
        color: #ffffff;
        margin: 0;
        line-height: 1.3;
      }
      .header-sub {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.7);
        letter-spacing: 1.5px;
        margin-top: 2px;
      }
    }
  }

  .card-body {
    padding: 24px 20px;
  }
}

/* ================= 表单 ================= */
.audit-form {
  /deep/ .el-form-item {
    margin-bottom: 20px;

    .el-form-item__label {
      font-weight: 500;
      color: @text-regular;
    }

    .el-input__inner {
      border-radius: 8px;
      height: 40px;
      transition: all 0.2s ease;

      &:hover { border-color: @primary; }
      &:focus {
        border-color: @primary;
        box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
      }
    }

    .el-textarea__inner {
      border-radius: 8px;
      transition: all 0.2s ease;

      &:hover { border-color: @primary; }
      &:focus {
        border-color: @primary;
        box-shadow: 0 0 0 3px rgba(64, 158, 255, 0.1);
      }
    }

    .el-radio-group {
      display: flex;
      align-items: center;
      height: 40px;

      .el-radio {
        margin-right: 20px;
      }
    }
  }
}

/* ================= 图片 ================= */
.section-divider {
  height: 1px;
  background: @border-color;
  margin: 4px 0 20px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: @text-primary;
  padding: 0 0 14px;
  position: relative;
  padding-left: 12px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 2px;
    width: 4px;
    height: 16px;
    background: @primary;
    border-radius: 2px;
  }
}

.image-grid {
  display: flex;
  gap: 60px;
  justify-content: center;
  flex-wrap: wrap;
}

.image-block {
  display: flex;
  flex-direction: column;
  align-items: center;

  .image-block-label {
    font-size: 14px;
    font-weight: 500;
    color: @text-regular;
    margin-bottom: 12px;
    text-align: center;
  }

  .image-wrap {
    width: 220px;
    height: 220px;
    border: 1px solid @border-color;
    border-radius: 10px;
    overflow: hidden;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    }

    .detail-image {
      width: 100%;
      height: 100%;
      display: block;

      /deep/ .el-image__inner {
        transition: transform 0.3s ease;
        &:hover { transform: scale(1.05); }
      }
    }

    .image-empty {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #fafbfc;
      color: @text-placeholder;
      gap: 8px;

      i { font-size: 36px; }
      span { font-size: 13px; }
    }
  }
}

/* ================= 流程图 ================= */
.process-diagram {
  /deep/ * {
    max-width: 100%;
    box-sizing: border-box;
  }
}

.empty-state {
  text-align: center;
  color: @text-placeholder;
  padding: 40px 0;
  font-size: 14px;
}

/* ================= 审批表单 ================= */
.approval-form {
  /deep/ .el-form-item {
    margin-bottom: 20px;

    .el-form-item__label {
      font-weight: 500;
      color: @text-regular;
    }
  }

  .el-button--primary {
    min-width: 140px;
    height: 42px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 15px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;

    i { font-size: 16px; }
  }
}

/* ================= 响应式 ================= */
@media screen and (max-width: 768px) {
  .flow-page {
    padding: 12px;
  }

  .table-container {
    .page-header {
      padding: 14px 16px;
    }
    .card-body {
      padding: 16px 12px;
    }
  }

  .image-grid {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }

  .image-block .image-wrap {
    width: 180px;
    height: 180px;
  }
}
</style>
